import React, { useMemo, useEffect } from "react";
import {
    MapContainer,
    TileLayer,
    Marker,
    Popup,
    Polyline,
    useMap
} from "react-leaflet";
import L from "leaflet";
import { PAXEL_STATUS_MAP } from "./paxelStatusMap";

// 🎨 helper icon
const createIcon = (color) =>
    new L.Icon({
        iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-${color}.png`,
        shadowUrl: "https://unpkg.com/leaflet@1.9.3/dist/images/marker-shadow.png",
        iconSize: [25, 41],
        iconAnchor: [12, 41],
    });

// 🎨 icons
const greenIcon = createIcon("green");
const blueIcon = createIcon("blue");
const redIcon = createIcon("red");

// 🧠 auto fit bounds
const FitBounds = ({ points }) => {
    const map = useMap();

    useEffect(() => {
        if (points.length > 0) {
            const bounds = L.latLngBounds(points);
            map.fitBounds(bounds, { padding: [50, 50] });
        }
    }, [points, map]);

    return null;
};

const TrackingMap = ({ data }) => {

    // 🔥 hook harus di atas (no condition)
    const processedLogs = useMemo(() => {
        if (!data?.logs) return [];

        const sorted = [...data.logs].sort(
            (a, b) => new Date(a.created_datetime) - new Date(b.created_datetime)
        );

        const unique = sorted.filter((v, i, a) =>
            i === a.findIndex(t => t.latitude === v.latitude && t.longitude === v.longitude)
        );

        return unique;
    }, [data]);

    // ⛔ baru boleh conditional return
    if (!data) return null;

    const origin = [data.origin.latitude, data.origin.longitude];
    const destination = [data.destination.latitude, data.destination.longitude];

    const logPoints = processedLogs.map(log => [
        log.latitude,
        log.longitude
    ]);

    const allPoints = [origin, ...logPoints, destination];

    return (
        <MapContainer
            center={origin}
            zoom={12}
            style={{
                height: "400px",
                width: "100%",
                //borderRadius: "10px"
                //height: "400px",
                //width: "100%",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 6px 24px rgba(0,0,0,0.12)"
            }}
        >
            {/*<TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />*/}
            <TileLayer
                url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png"
            />

            {/* 🔥 auto zoom */}
            <FitBounds points={allPoints} />

            {/* 🟢 Origin */}
            <Marker position={origin} icon={greenIcon}>
                <Popup>
                    <b>Origin</b><br />
                    {data.origin.name}
                </Popup>
            </Marker>

            {/* 🔴 Destination */}
            <Marker position={destination} icon={redIcon}>
                <Popup>
                    <b>Destination</b><br />
                    {data.destination.name}
                </Popup>
            </Marker>

            {/* 🔵 Logs */}
            {processedLogs.map((log, i) => (
                <Marker
                    key={i}
                    position={[log.latitude, log.longitude]}
                    icon={blueIcon}
                >
                    <Popup>
                        <b>{PAXEL_STATUS_MAP[log.status] || log.status}</b><br />
                        {log.created_datetime}<br />
                        {log.note === "-" ? "No notes" : log.note}
                    </Popup>
                </Marker>
            ))}

            {/* ➝ Route */}
            <Polyline
                positions={allPoints}
                pathOptions={{
                    color: "#3b82f6",
                    weight: 4,
                    opacity: 0.7
                }}
            />
            {/*<Polyline positions={allPoints} /> */}
        </MapContainer>
    );
};

export default TrackingMap;